import { render, staticRenderFns } from "./FocusedCompletionPrompt.vue?vue&type=template&id=cbc9b4f0"
import script from "./FocusedCompletionPrompt.vue?vue&type=script&lang=ts"
export * from "./FocusedCompletionPrompt.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports